import styled from 'styled-components';

const SearchIcon = styled.img`
    position: absolute;
    left: 18.5px;
    top: 14.5px;
`;

export default SearchIcon;